import { render } from "./FPluginProduct.vue?vue&type=template&id=75a36c87&scoped=true"
import script from "./FPluginProduct.vue?vue&type=script&lang=js"
export * from "./FPluginProduct.vue?vue&type=script&lang=js"

import "./FPluginProduct.vue?vue&type=style&index=0&id=75a36c87&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a36c87"]])

export default __exports__